import { ValueConverter } from './value-converter';

export type IIdentifiable = {
    id: number;
    [key: string]: any;
} | {
    externalId: string;
    [key: string]: any;
}

export class IdentifiableValueConverter implements ValueConverter<number | null, IIdentifiable | null | undefined> {
    public items: IIdentifiable[] = [];

    public constructor(
        items: IIdentifiable[],
        private readonly identifiableProperty: 'id' | 'externalId' = 'id'
    ) {
        this.items = items;
    }

    public convert(value: number | null): IIdentifiable | null | undefined {
        return value === null ? null : this.items.filter(i => i[this.identifiableProperty] === value).shift();
    }

    public convertBack(obj?: IIdentifiable | null): number | null {
        return obj ? obj[this.identifiableProperty] : null;
    }

    public refreshItems(items: IIdentifiable[]) {
        this.items = items;
    }
}
